import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root';
import { UserActions } from './model';

export const SIGNUP_JTBD_FEATURE_KEY = 'signupJtbd';

interface SignupJTBDState {
  feedbackCount: { good?: number; bad?: number };
  showAgentWorkingModal: boolean;
  showGetOnWhatsappStrip: boolean;
  showOnboardingDialogSignup: boolean;
  quickUserActions: UserActions;
}

const initialSignupJTBDState: SignupJTBDState = {
  feedbackCount: { good: 0, bad: 0 },
  showAgentWorkingModal: true,
  showGetOnWhatsappStrip: false,
  showOnboardingDialogSignup: true,
  quickUserActions: {
    sentHi: false,
    viewedCatalogue: false,
  },
};

export const signupJTBDSlice = createSlice({
  name: SIGNUP_JTBD_FEATURE_KEY,
  initialState: initialSignupJTBDState,
  reducers: {
    updateFeedbackCount(
      state,
      action: PayloadAction<{ good: number; bad: number }>
    ) {
      state.feedbackCount = action.payload;
    },
    updateFeedbackBadCount(state) {
      state.feedbackCount.bad = (state.feedbackCount.bad ?? 0) + 1;
    },
    updateFeedbackGoodCount(state) {
      const count = state.feedbackCount.good ?? 0;
      if (!state.showGetOnWhatsappStrip) {
        state.showGetOnWhatsappStrip = true;
      }
      state.feedbackCount.good = count + 1;
    },
    updateShowAgentWorkingModal(state, action: PayloadAction<boolean>) {
      state.showAgentWorkingModal = action.payload;
    },
    updateShowGetOnWhatsappStrip(state, action: PayloadAction<boolean>) {
      state.showGetOnWhatsappStrip = action.payload;
    },
    updateShowOnboardingDialogSignup(state, action: PayloadAction<boolean>) {
      state.showOnboardingDialogSignup = action.payload;
    },
    updateQuickUserActions(
      state,
      action: PayloadAction<{ key: keyof UserActions; value: boolean }>
    ) {
      const { key, value } = action.payload;
      state.quickUserActions[key] = value;
    },
  },
});

export const {
  updateFeedbackCount,
  updateFeedbackBadCount,
  updateFeedbackGoodCount,
  updateShowAgentWorkingModal,
  updateShowGetOnWhatsappStrip,
  updateShowOnboardingDialogSignup,
  updateQuickUserActions,
} = signupJTBDSlice.actions;

export const getSignupJTBDSliceState = (
  rootState: RootState
): SignupJTBDState => rootState[SIGNUP_JTBD_FEATURE_KEY];

export const getFeedbackCount = createSelector(
  getSignupJTBDSliceState,
  (state) => state.feedbackCount
);

export const getFeedbackBadCount = createSelector(
  getSignupJTBDSliceState,
  (state) => state.feedbackCount.good ?? 0
);

export const getFeedbackGoodCount = createSelector(
  getSignupJTBDSliceState,
  (state) => state.feedbackCount.bad ?? 0
);

export const getShowAgentWorkingModal = createSelector(
  getSignupJTBDSliceState,
  (state) => state.showAgentWorkingModal
);

export const getShowGetOnWhatsappStrip = createSelector(
  getSignupJTBDSliceState,
  (state) => state.showGetOnWhatsappStrip
);

export const getShowOnboardingModalSignup = createSelector(
  getSignupJTBDSliceState,
  (state) => state.showOnboardingDialogSignup
);

export const getQuickUserActions = createSelector(
  getSignupJTBDSliceState,
  (state) => state.quickUserActions
);
